import { Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { NotificationTypes } from "src/app/app.enums";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { ShopifyService } from "src/app/Services/shopify-service/shopify.service";
import {  WoocomerceService, WoocommerceCredentials } from "src/app/Services/woocomerce-service/woocomerce.service";
import { ConnectWoocommerceAccountComponent } from "../connect-woocommerce-account/connect-woocommerce-account.component";
import { ShopifyAccount } from "../shopify-account/shopify-account.component";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'shopify-and-woocommerce-dailog',
    templateUrl: './shopify-and-woocommerce-dailog.component.html',
    inputs: ['isAddPlatformAccountDailogVisible', 'platform'],
    outputs: ['onClosePlatformCredentialDailog'],
    standalone: false
})

export class ShopifyAndWooCommerceDailog implements OnInit{
  public storeUrl: string = '';
  public woocommerceFormData!: WoocommerceCredentials;
  public isAddPlatformAccountDailogVisible!: boolean;
  public platform!: 'shopify' | 'woocommerce';
  public onClosePlatformCredentialDailog = new EventEmitter<boolean>();

  constructor(
    private ngxSpinnerService: NgxSpinnerService,
    private shopifyService: ShopifyService,
    private notificationsService: NotificationsService,
    private woocommerceService: WoocomerceService,
    private transloco: TranslocoService){
    this.woocommerceFormData = new WoocommerceCredentials();
  }

  ngOnInit(): void {
    
  }
  
  public onClosePlatformAccountDailog(){
    this.isAddPlatformAccountDailogVisible = false
    this.onClosePlatformCredentialDailog.emit(this.isAddPlatformAccountDailogVisible)
  }

  public onConnectWooCommerceAccount(){
    this.ngxSpinnerService.show();
    this.woocommerceService.createWoocommerceAccount(this.woocommerceFormData).subscribe((response) => {
      console.log('Woocommerce account created successfully:', response);
      if (response.Success) {
          window.location.href = response.ResponseData;
      }
      this.ngxSpinnerService.hide();
      this.isAddPlatformAccountDailogVisible = false;
      },
      (error) => {
      this.ngxSpinnerService.hide();
      console.error('Error adding Woocommerce account details:', error);
      }
    );
  }

  public onConnectShopifyAccount(){
    this.ngxSpinnerService.show();
    this.shopifyService.connectWithShopifyAccount(this.storeUrl).subscribe((response) => {
      if (response.Success) {
          this.ngxSpinnerService.hide();
          console.log('Shopify account connection successful:', response);
          // localStorage.setItem(AppSettings.ON_SHOPIFY_CHECKOUT_SUCCESS, 'true');
          window.location.href = response.ResponseData;
      }
    },
    (error) => {
      this.ngxSpinnerService.hide();
      console.error('Failed to connect to Shopify account:', error);
      this.notificationsService.showNotification(this.transloco.translate('shopifyAndWoocomerceDailog.connectionFailedTitle'),this.transloco.translate('shopifyAndWoocomerceDailog.errorConnectingShopifyAccount'),NotificationTypes.Error);
    });
  }

}
